<app-dynamic-content *ngIf="!lmsUserService.IsLoggedIn"
  blocktitle="Marketing - Course List Page - Anonymous">
</app-dynamic-content>
<app-dynamic-content blocktitle="Marketing - Course List Page - {{lmsUserService.User.GetMemberTypes('ABMP').shift()}}">
</app-dynamic-content>
<h1 class="d-none d-md-block">Online Courses</h1>

<app-course-list></app-course-list>
